import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { withRights } from '../../../../../providers/RightsConsumer';

// material-ui components
import { Grid, TableCell, TableRow } from '@mui/material';

// core components
import { Autocomplete } from '@totalsoft/rocket-ui';
import BlockIcon from '@mui/icons-material/Block';
import { ScoringTextField } from '../styles/DocumentScoringStyles';

class DocumentScoringCategoryRowComponent extends React.PureComponent {
  functionCache = new Map();

  cacheFunction = (key, func) => {
    let f = this.functionCache.get(key);
    if (!f) {
      f = func.bind(this);
      this.functionCache.set(key, f);
    }
    return f;
  };

  handleCategoryValueChange = value => {
    this.props.onPropertyChange('value', value);
  };

  handleOptionChange = option => {
    this.props.onPropertyChange('option', option);
  };

  hiddenSensitiveData = () => {
    if (this.props.category.sensitiveInfo && !this.props.rights.clientSensitiveInfoRead) {
      return true;
    }

    return false;
  };

  render() {
    const { rights, options, category, validationInfo, t, disabled, viewScoringDetailLimits, scoringGridCategoryScoreRead } = this.props;

    return (
      <TableRow>
        <TableCell>{category.name}</TableCell>
        {this.hiddenSensitiveData() || category.valueInputTypeCode !== 'NUMERIC' ? (
          <TableCell align='right'>{''}</TableCell>
        ) : (
          <TableCell align='right'>
            <ScoringTextField
              fullWidth
              isNumeric
              value={category.value}
              inputProps={{ decimalScale: category.scale ? category.scale : 2 }}
              onChange={this.handleCategoryValueChange}
              disabled={rights.readOnlyFull || category.isReadOnly || disabled}
              error={validationInfo && validationInfo.value ? true : false}
            />
          </TableCell>
        )}
        {this.hiddenSensitiveData() ? (
          <TableCell align='left' style={{ padding: '0px 0px 4px 0px' }}>
            <Grid container spacing={1} justifyContent='flex-start'>
              <Grid item align='left'></Grid>
              <BlockIcon />
              <Grid item style={{ paddingLeft: '20px' }}>
                {t('OfferEdit.Client.IncomeData.SensitiveInfo')}
              </Grid>
            </Grid>
          </TableCell>
        ) : (
          <TableCell>
            <Autocomplete
              fullWidth
              labelKey='name'
              valueKey='scoringCategoryOptionId'
              value={category.option || ''}
              isSearchable={true}
              simpleValue={false}
              isClearable={false}
              onChange={this.handleOptionChange}
              options={options}
              disabled={rights.readOnlyFull || category.isReadOnly || disabled}
              error={validationInfo && validationInfo.option ? true : false}
              renderInput={params => <ScoringTextField {...params} />}
            />
          </TableCell>
        )}
        {viewScoringDetailLimits && (
          <TableCell align='right' colSpan={1}>
            {!(category.option && category.option.minValue) ? '' : t('NUMBER', { number: category.option.minValue })}
          </TableCell>
        )}
        {viewScoringDetailLimits && (
          <TableCell align='right' colSpan={1}>
            {!(category.option && category.option.maxValue) ? '' : t('NUMBER', { number: category.option.maxValue })}
          </TableCell>
        )}
        {scoringGridCategoryScoreRead && (
          <TableCell align='right' colSpan={1}>
            {this.hiddenSensitiveData() || (!category.score && category.score !== 0) ? '' : t('DECIMAL4', { number: category.score })}
          </TableCell>
        )}
      </TableRow>
    );
  }
}

DocumentScoringCategoryRowComponent.propTypes = {
  category: PropTypes.object.isRequired,
  options: PropTypes.array.isRequired,
  onPropertyChange: PropTypes.func.isRequired,
  validationInfo: PropTypes.object.isRequired,
  rights: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
  viewScoringDetailLimits: PropTypes.bool.isRequired,
  scoringGridCategoryScoreRead: PropTypes.bool.isRequired
};

export default withTranslation()(withRights(DocumentScoringCategoryRowComponent));
